import React from 'react'
import { useStyles } from './styles'
import { Box, Loader } from '@mantine/core'

const Loading = () => {
    const {classes} = useStyles(useStyles)
    return (
        <Box className={classes.loaderWrapper}>
            <Loader variant="dots" color="#00D095" size="10rem" />
        </Box>
    )
}

export default Loading